// @ts-nocheck
import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'
import * as R from 'ramda'

import styles from './Checkbox.module.scss'

export const Checkbox = React.forwardRef(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isIndeterminate = false,
      isRequired = false,
    },
    ref,
  ) => {
    React.useEffect(() => {
      if (!R.isNil(isIndeterminate) && ref.current) {
        ref.current.indeterminate = isIndeterminate
      }
    }, [ref, isIndeterminate])

    return (
      <input
        className={cx(styles.checkbox, {
          [fieldClassName]: Boolean(fieldClassName),
          [styles.invalid]: Boolean(error),
        })}
        type="checkbox"
        checked={value}
        disabled={isDisabled}
        required={isRequired}
        {...{ id, name, placeholder, ref, onBlur, onChange }}
      />
    )
  },
)

export const ControlledCheckbox = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Checkbox
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
